import { ALL_FILTER_OPTION, createAllSelection } from "@/helpers/all";
import { Filter } from "@/types/filters";

export const defaultSelectedOutputFilters = ["businessGoalPropertyValue", "plan", "scenario", "mediaType"];

export type ScenarioNode = {
  id: string;
  label: string;
  children?: ScenarioNode[];
};

export type ProjectOutputFilterParams = {
  scenario: string[] | ScenarioNode[] | null;
  plan: string[] | null;
  mediaType: string[] | null;
  businessGoalPropertyValue: string[] | null;
};

export const defaultPlanOutputFilterValues: ProjectOutputFilterParams = {
  plan: createAllSelection(),
  scenario: createAllSelection(),
  businessGoalPropertyValue: createAllSelection(),
  mediaType: createAllSelection(),
};

export const planOutputFilters: Array<Filter> = [
  {
    label: "Business Goal",
    filterName: "MultipleSelectFilter",
    filterKey: "businessGoalPropertyValue",
    apiKey: "business_goal_property_values",
    value: null,
    isPageDetails: true,
    items: [ALL_FILTER_OPTION],
  },
  {
    label: "Plan",
    filterName: "MultipleSelectFilter",
    filterKey: "plan",
    apiKey: "plans",
    value: null,
    items: [ALL_FILTER_OPTION],
  },
  {
    label: "Scenario",
    filterName: "PlanScenarioTreeSelectFilter",
    filterKey: "scenario",
    apiKey: "scenarios",
    value: null,
    items: [ALL_FILTER_OPTION],
  },
  {
    label: "Media Type",
    filterName: "MultipleSelectFilter",
    filterKey: "mediaType",
    apiKey: "mediaType",
    value: null,
    items: [ALL_FILTER_OPTION],
  },
];
